const NES_WIDTH = 256;
const NES_HEIGHT = 240;

export class MobileScreen {
  private readonly ctx: CanvasRenderingContext2D;
  private readonly bufferCanvas: HTMLCanvasElement;
  private readonly bufferCtx: CanvasRenderingContext2D;
  private readonly bufferImage: ImageData;
  private readonly handleResize = () => this.resize();

  constructor(private readonly canvas: HTMLCanvasElement) {
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Failed to get 2d context');
    }

    this.ctx = context;
    this.ctx.imageSmoothingEnabled = false;

    this.bufferCanvas = document.createElement('canvas');
    this.bufferCanvas.width = NES_WIDTH;
    this.bufferCanvas.height = NES_HEIGHT;

    const bufferContext = this.bufferCanvas.getContext('2d');
    if (!bufferContext) {
      throw new Error('Failed to get buffer context');
    }

    this.bufferCtx = bufferContext;
    this.bufferImage = this.bufferCtx.createImageData(NES_WIDTH, NES_HEIGHT);

    window.addEventListener('resize', this.handleResize);
    this.resize();
  }

  public onFrame(frame: Uint32Array): void {
    const data = this.bufferImage.data;
    let ptr = 0;

    for (let i = 0; i < frame.length; i++) {
      const value = frame[i];
      data[ptr++] = (value >> 16) & 0xFF;
      data[ptr++] = (value >> 8) & 0xFF;
      data[ptr++] = value & 0xFF;
      data[ptr++] = 255;
    }

    this.bufferCtx.putImageData(this.bufferImage, 0, 0);
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.drawImage(this.bufferCanvas, 0, 0, this.canvas.width, this.canvas.height);
  }

  public dispose(): void {
    window.removeEventListener('resize', this.handleResize);
  }

  private resize(): void {
    const parent = this.canvas.parentElement;
    const availableWidth = parent?.clientWidth ?? window.innerWidth;
    const availableHeight = parent?.clientHeight ?? window.innerHeight * 0.6;
    const scale = Math.max(0.5, Math.min(availableWidth / NES_WIDTH, availableHeight / NES_HEIGHT));
    const dpr = window.devicePixelRatio || 1;

    const displayWidth = NES_WIDTH * scale;
    const displayHeight = NES_HEIGHT * scale;

    this.canvas.style.width = `${displayWidth}px`;
    this.canvas.style.height = `${displayHeight}px`;

    this.canvas.width = Math.round(displayWidth * dpr);
    this.canvas.height = Math.round(displayHeight * dpr);

    this.ctx.imageSmoothingEnabled = false;
  }
}
